"use client";
import { useEffect, type ReactNode } from "react";

// Lightweight SmoothScroll — Lenis removed because its RAF loop conflicts
// with framer-motion's useScroll/useSpring on every frame, burning the main
// thread and causing input focus to freeze the page.
export function SmoothScroll({ children }: { children: ReactNode }) {
  return <>{children}</>;
}